<div class="flex items-center justify-start gap-4 mb-6">
  <h2 class="text-xl font-semibold">Metodo di pagamento</h2>
  <button
    class="bg-blue-600 text-white font-semibold px-4 py-2 rounded shadow hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
    [disabled]="!selectedMethod || isLoading"
    (click)="avantiStep()"
  >
    Avanti >>
  </button>
</div>

<!-- Loader -->
<div *ngIf="isLoading" 
     class="mb-6 flex flex-col items-center justify-center text-gray-700 font-medium text-center">
  <svg class="animate-spin h-16 w-16 text-blue-500 mb-3"
       xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <circle class="opacity-25" cx="12" cy="12" r="10"
            stroke="currentColor" stroke-width="4"></circle>
    <path class="opacity-75" fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
  </svg>
  <div class="text-gray-600 mt-2">
    <h3 class="mb-2">Emissione della polizza in corso</h3>
    <p>Stiamo emettendo la tua polizza, l'operazione potrebbe richiedere fino a un minuto</p>
  </div>
</div>

<!-- Sezione Errore -->
<div *ngIf="errore" class="border border-red-300 bg-red-50 rounded-lg p-4 shadow mb-6">
  <div class="flex items-center gap-2 mb-2 text-red-700 font-semibold">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M12 2a10 10 0 100 20 10 10 0 000-20z" />
    </svg>
    Abbiamo riscontrato degli errori!
  </div>
  <p class="text-sm text-red-600">Errore temporaneo. Riprova più tardi.</p>
</div>

<div *ngIf="!isLoading">
  <p class="mb-6">Seleziona una modalità di pagamento tra quelle presenti qui sotto:</p>
  <!-- Selettori Metodo -->
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
    <div
      (click)="selezionaMetodo('SDD')"
      [class.border-gray-600]="selectedMethod === 'SDD'"
      class="border rounded-lg p-4 cursor-pointer hover:border-gray-500 transition-all border-gray-300 text-center"
    >
      <div class="mb-2 flex justify-center">
        <!-- Icona banca -->
        <svg
          class="w-16 h-16 text-gray-700 group-hover:text-gray-900 transition-colors"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <!-- tetto -->
          <path d="M3 9L12 3l9 6" />
          <!-- linea sotto tetto -->
          <path d="M4 10h16" />
          <!-- colonne -->
          <path d="M7 10v7M12 10v7M17 10v7" />
          <!-- base -->
          <path d="M4 21h16" />
        </svg>
      </div>
      <h3 class="text-lg font-semibold">Pagamento diretto in banca (SDD)</h3>
    </div>

    <div
      (click)="selezionaMetodo('EXTERNAL_PROVIDER')"
      [class.border-gray-600]="selectedMethod === 'EXTERNAL_PROVIDER'"
      class="border rounded-lg p-4 cursor-pointer hover:border-gray-500 transition-all border-gray-300 text-center"
    >
      <div class="mb-2 flex justify-center">
        <!-- Icona carta di pagamento -->
        <svg
          class="w-16 h-16 text-gray-700 group-hover:text-gray-900 transition-colors"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <!-- corpo carta -->
          <rect x="3" y="6" width="18" height="12" rx="2" />
          <!-- banda -->
          <path d="M3 10h18" />
          <!-- dettagli pagamento -->
          <path d="M7 15h5M7 18h3" />
        </svg>
      </div>
      <h3 class="text-lg font-semibold">Carta di credito o debito</h3>
    </div>
  </div>

  <!-- Campi aggiuntivi per SDD -->
  <div *ngIf="selectedMethod === 'SDD'" class="mt-6 space-y-6 p-6 border rounded-lg border-gray-300">
    <!-- Intestatario IBAN -->
    <div>
      <h4 class="text-lg font-semibold mb-2">Intestatario IBAN</h4>
      <div class="grid md:grid-cols-4 gap-4">
        <div>
          <label class="block mb-1 font-medium">IBAN *</label>
          <input type="text"
                [(ngModel)]="codiceIban"
                name="codiceIban"
                #ibanRef="ngModel"
                required
                [class.border-red-500]="ibanRef.invalid && ibanRef.touched"
                class="w-full border rounded px-3 py-2" />
          <p *ngIf="ibanRef.invalid && ibanRef.touched" class="text-sm text-red-500 mt-1">
            Campo obbligatorio
          </p>
        </div>
        <div>
          <label class="block mb-1 font-medium">Partita IVA *</label>
          <input type="text"
                [(ngModel)]="codiceFiscaleIntestatario"
                name="codiceFiscaleIntestatario"
                #cfRef="ngModel"
                required
                [class.border-red-500]="cfRef.invalid && cfRef.touched"
                class="w-full border rounded px-3 py-2" />
          <p *ngIf="cfRef.invalid && cfRef.touched" class="text-sm text-red-500 mt-1">
            Campo obbligatorio
          </p>
        </div>
        <div>
          <label class="block mb-1 font-medium">Ragione Sociale *</label>
          <input type="text"
                [(ngModel)]="nomeIntestatario"
                name="nomeIntestatario"
                #nomeRef="ngModel"
                required
                [class.border-red-500]="nomeRef.invalid && nomeRef.touched"
                class="w-full border rounded px-3 py-2" />
          <p *ngIf="nomeRef.invalid && nomeRef.touched" class="text-sm text-red-500 mt-1">
            Campo obbligatorio
          </p>
        </div>
        <div>
          <label class="block mb-1 font-medium">Sede Legale *</label>
          <input type="text"
                [(ngModel)]="indirizzoIntestatario"
                name="indirizzoIntestatario"
                #indirizzoRef="ngModel"
                required
                [class.border-red-500]="indirizzoRef.invalid && indirizzoRef.touched"
                class="w-full border rounded px-3 py-2" />
          <p *ngIf="indirizzoRef.invalid && indirizzoRef.touched" class="text-sm text-red-500 mt-1">
            Campo obbligatorio
          </p>
        </div>
      </div>
    </div>

    <!-- Contraente -->
    <div>
      <h4 class="text-lg font-semibold mb-2">Contraente della Polizza</h4>
      <div class="grid md:grid-cols-2 gap-4">
        <div>
          <label class="block mb-1 font-medium">Partita IVA *</label>
          <input type="text"
                [(ngModel)]="codiceFiscaleContraente"
                name="codiceFiscaleContraente"
                #aziendaContraenteRef="ngModel"
                required
                [class.border-red-500]="aziendaContraenteRef.invalid && aziendaContraenteRef.touched"
                class="w-full border rounded px-3 py-2" />
          <p *ngIf="aziendaContraenteRef.invalid && aziendaContraenteRef.touched" class="text-sm text-red-500 mt-1">
            Campo obbligatorio
          </p>
        </div>
        <div>
          <label class="block mb-1 font-medium">Ragione Sociale *</label>
          <input type="text"
                [(ngModel)]="nomeContraente"
                name="nomeContraente"
                #nomeContraenteRef="ngModel"
                required
                [class.border-red-500]="nomeContraenteRef.invalid && nomeContraenteRef.touched"
                class="w-full border rounded px-3 py-2" />
          <p *ngIf="nomeContraenteRef.invalid && nomeContraenteRef.touched" class="text-sm text-red-500 mt-1">
            Campo obbligatorio
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Riepilogo -->
  <div *ngIf="preventivo" class="mb-6 mt-6">
    <h3 class="text-green-700">Importo Polizza {{ preventivo.importo | currency:preventivo.valuta }}</h3>
  </div>

  <!-- Sezione Riepilogo Beni Assicurati -->
  <div *ngIf="preventivo && voci.length > 0" class="mb-8">
    <h4 class="text-lg font-semibold mb-4 text-gray-800">Riepilogo Beni Assicurati</h4>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-4">
      <ng-container *ngFor="let voce of voci; let i = index">
        <div class="border border-blue-900 rounded-md p-3 text-sm">
          <h5 class="font-semibold text-base mb-2 text-gray-800">Bene {{ i + 1 }}: {{ voce.etichetta || voce.targa }}</h5>
          <p><strong class="text-gray-600">Targa / N. Patente:</strong> {{ voce.targa }}</p>
          <p><strong class="text-gray-600">Tipo patente:</strong> {{ voce.tipoPatente }}</p>
          <p><strong class="text-gray-600">Massimale:</strong> {{ massimale | number:'1.0-0' }} €</p>
          <p><strong class="text-gray-600">Diaria:</strong> {{ voce.diaria }} € per {{ voce.giorni }} giorni</p>
          <p><strong class="text-gray-600">Coperture:</strong></p>
          <ul class="list-disc list-inside text-gray-700">
            <li *ngFor="let c of voce.coperture">{{ c }}</li>
          </ul>
        </div>
      </ng-container>
    </div>
  </div>

</div>
